import { useThunkDispatch } from '@campaignhub/react-hooks'
import { useSelector } from 'react-redux'

import * as serviceJobChecklistItemActions from '@redux/modules/serviceJobChecklistItem'

const createServiceJobChecklistItem = (checklistItem, dispatch, requestOptions) => {
  const { createServiceJobChecklistItem: createFn } = serviceJobChecklistItemActions
  return dispatch(createFn(checklistItem, requestOptions))
}

const updateServiceJobChecklistItem = (checklistDetail, dispatch, requestOptions) => {
  const { updateServiceJobChecklistItem: updateFn } = serviceJobChecklistItemActions
  return dispatch(updateFn(checklistDetail, requestOptions))
}

const deleteServiceJobChecklistItem = (checklistItem, dispatch) => {
  const { deleteServiceJobChecklistItem: deleteFn } = serviceJobChecklistItemActions
  return dispatch(deleteFn(checklistItem))
}

const useServiceJobChecklistItem = () => {
  const dispatch = useThunkDispatch()
  const entities = useSelector(reduxState => reduxState.entities)
  const { serviceJobChecklistItems } = entities

  const { creating, deleting, updating } = useSelector(reduxState => reduxState.serviceJobChecklistItems)

  return {
    callbacks: {
      createServiceJobChecklistItem: (checklistItem, requestOptions) => createServiceJobChecklistItem(checklistItem, dispatch, requestOptions),
      deleteServiceJobChecklistItem: (checklistItem) => deleteServiceJobChecklistItem(checklistItem, dispatch),
      updateServiceJobChecklistItem: (checklistDetail, requestOptions) => updateServiceJobChecklistItem(checklistDetail, dispatch, requestOptions),
    },
    creating,
    deleting,
    serviceJobChecklistItems,
    updating,
  }
}

export default useServiceJobChecklistItem
